import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

// TopRightMenu new Props - HTML/Mode

@Component({
  name: 'GridSeparator'
})
export default class GridSeparator extends Vue {

  render(h) {
    return (
      <div class="grid-separator">
        <div class="separator">
        </div>
        <div class="section-title">
          {this.$slots.default}
        </div>
      </div>
    );
  }
}
